(ns common.schema.entities.fee.core
  "Common entity-type definition of the fee. It was an entry in
   `common.schema.entity-types`. The backend registry needs it, so that the
   dedicated index builds the fee documents with the calculated fields."
  (:require
   [common.schema.entities.fee.schema :as fee]
   [common.schema.entities.fee.permissions :as permissions]))

(def entity-type-definition
  {:entity-type                  :entity.type/fee
   :schema                       fee/schema
   :name                         {:en "Fee"}
   :plural                       {:en "Fees"}
   :icon                         :fa-comments-dollar
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
